var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { camelCase } from "change-case";
var isJSONString = function (content) {
    try {
        JSON.parse(content);
    }
    catch (e) {
        return false;
    }
    return true;
};
var isMethodString = function (content) {
    if (content.endsWith("()")) {
        var methodMatchRegEx = /[a-zA-Z_$][0-9a-zA-Z_$]*/;
        if (content.match(methodMatchRegEx)) {
            return true;
        }
    }
    return false;
};
export var attributeToProps = function (element) {
    var props = {};
    element.getAttributeNames().forEach(function (attribute) {
        var _a, _b, _c;
        var content = element.getAttribute(attribute);
        if (attribute && content) {
            if (isMethodString(content)) {
                props = __assign(__assign({}, props), (_a = {}, _a[camelCase(attribute)] = function (data) { return eval("".concat(content.replace("()", ""), "(").concat(JSON.stringify(data), ")")); } //security risk
                , _a));
            }
            else if (isJSONString(content)) {
                props = __assign(__assign({}, props), (_b = {}, _b[camelCase(attribute)] = JSON.parse(content), _b));
            }
            else {
                props = __assign(__assign({}, props), (_c = {}, _c[camelCase(attribute)] = content, _c));
            }
        }
    });
    return props;
};
//# sourceMappingURL=web-component.js.map